import { Stack, Typography } from "@mui/material";
import { ShieldIcon } from "../assets";
import styles from "./ConfirmationTableHeader.module.css";
import EditButton from "./EditButton";

type ConfirmationTableHeader = {
	title: string;
	onEdit: () => void;
};

export default function ConfirmationTableHeader({ title, onEdit }: ConfirmationTableHeader) {
	return (
		<div className={styles.header}>
			<Stack direction="row" gap="8px">
				<ShieldIcon />
				<Typography className={styles.title}>{title}</Typography>
			</Stack>
			<EditButton onClick={onEdit} />
		</div>
	);
}
